/* eslint-disable max-len */
import { COLOR_CONSTANTS } from './scss-variables.generated';

export const CONSTANTS = {
    budgetTypes: ['DAILY', 'WEEKLY', 'MONTHLY'],
    defaultThreshold: 75,
    percMaxLength: 75,
    budgetFormValueDefault: 200,
    budgetFormValueMin: 1,
    budgetFormValueMax: 1000000000,
    applianceTypes: [
        'All Usage',
        'Outdoor and Indoor',
        'Outdoor',
        'Indoor',
        'Showers',
        'Toilets',
        'Water Softener',
        'Dishwasher',
        'Clothes Washer',
    ],
    applianceTypes_Flume1: ['All Usage', 'Outdoor and Indoor', 'Outdoor', 'Indoor'],
    applianceKeys: [
        'all',
        'outdoor',
        'indoor',
        'shower',
        'toilet',
        'softener',
        'dish_washer',
        'clothes_washer',
        'pool',
        'reverse_osmosis',
    ],
    spanTypeKeys: [
        'OUTDOOR',
        'INDOOR',
        'SHOWER',
        'TOILET',
        'SOFTENER',
        'CLOTHES_WASHER',
        'DISH_WASHER',
        'POOL',
        'REVERSE_OSMOSIS',
    ],
    stackedDatasetKey: 1,
    indoorOutdoorCategoryKey: 1,
    outdoorCategoryKey: 2,
    indoorCategoryKey: 3,
    allCategoryKey: 0,
    breakdownChartLegend: {
        outdoor: {
            label: 'Outdoor',
            color: COLOR_CONSTANTS['$irrigation-blue'],
        },
        indoor: {
            label: 'Indoor',
            color: COLOR_CONSTANTS['$river-blue'],
        },
        indoorUncat: {
            label: 'Indoor (Uncatetgorized)',
            color: COLOR_CONSTANTS['$river-blue'],
        },
        shower: {
            label: 'Shower',
            color: COLOR_CONSTANTS['$sea-spray-blue'],
        },
        toilet: {
            label: 'Toilet',
            color: COLOR_CONSTANTS['$soft-green'],
        },
        softener: {
            label: 'Water Softener',
            color: COLOR_CONSTANTS['$cut-grass'],
        },
        clothes_washer: {
            label: 'Clothes Washer',
            color: COLOR_CONSTANTS['$clotheswasher-red'],
        },
        dish_washer: {
            label: 'Dishwasher',
            color: COLOR_CONSTANTS['$dishwasher-pink'],
        },
    },
    helpCenterLinks: {
        detailPlus: 'https://help.flumewater.com/en/articles/5884437-introducing-detail',
        compare: 'https://help.flumewater.com/en/articles/5872341-detail-comparisons',
        battery: 'https://help.flumewater.com/en/articles/4868759-how-to-order-flume-2-batteries',
    },
    insightBreakdownHelpString:
        'Flume uses machine learning technology to provide you with an estimate of detailed water use. It is possible that Flume may not label an event or mislabel an event as an incorrect appliance. The total amount of overall water usage should still be accurate. We are constantly working to improve these breakdowns. You can provide feedback with the button below. If you would like to help improve our machine learning by relabeling any incorrrect labels, please use the "Event Review" section in the web app. (Note: This will not immediately prevent usage from being labeled incorrectly in the future.)',
    legacyBreakdownHelpString:
        'Flume uses machine learning technology to provide you with a more detailed look at your water use. We are constantly working to improve these breakdowns; if you see something that looks off, let us know by clicking Feedback.',
    breakdownHelpString2:
        'To view different appliances, select the appliance(s) you’d like to take a closer look at under “Selected Water Appliances”.',
    compareString:
        'You can now compare your water usage to the previous hour, day, week, month, or year! Turn on this feature by tapping the box next to “Compare to Last [time period]”, located under your graph. The time period in which you are viewing your water usage will be the same time period compared. So, if you are viewing a week of water data, Flume will provide a comparison to the previous week.',
    similarHouseholdString:
        'Flume’s “Compare to Similar Household” feature is under construction as we make some upgrades to bring you new levels of detail and accuracy. Flume’s “Compare to Similar Household” feature will be back and better than ever before you know it.',
};
